import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createKey, getKeys } from 'redux/apiKeysSlice';
import PropTypes from 'prop-types';

const FormularioKeys = ({ callToast }) => {
  const [value, setValue] = useState('');
  const [web_hook, setWebhook] = useState('');
  const dispatch = useDispatch();
  const userLogged = useSelector(state => state.login.currentUser);

  const handleSubmit = async () => {
    const res = await dispatch(createKey(userLogged.id, value, web_hook, 730));

    if (res.status < 300) {
      callToast(
        '¡API Key creada!',
        'La API Key fue creada correctamente.',
        'Justo ahora'
      );
      dispatch(getKeys(userLogged.id));
    } else
      callToast(
        'Algo salió mal...',
        res.message || 'La API Key no pudo ser creada. Inténtelo de nuevo.',
        'Justo ahora'
      );
  };

  return (
    <Card className="bg-white">
      <Card.Header className="border-bottom">
        <Card.Title>Crear nueva clave</Card.Title>
      </Card.Header>

      <Card.Body>
        <Row>
          <Col>
            <input
              placeholder="Nombre de la aplicación"
              className="form-control"
              value={value}
              onChange={e => setValue(e.target.value)}
            />
            <input
              placeholder="Webhook URL (opcional)"
              className="form-control mt-2"
              value={web_hook}
              onChange={e => setWebhook(e.target.value)}
            />
            <Button
              className="d-flex align-items-center justify-content-center mt-3"
              variant="success"
              size="sm"
              onClick={value ? handleSubmit : () => {}}
              disabled={!value}
              style={{ width: '100%' }}
            >
              <FontAwesomeIcon icon="fa-check" style={{ marginRight: 5 }} />
              <span style={{ marginRight: 10 }}>Crear clave</span>
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

FormularioKeys.propTypes = {
  callToast: PropTypes.func.isRequired
};

export default FormularioKeys;
